(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/retailer-login/assets/javascripts/retailer-login.js') >= 0) return;  svs.modules.push('/modules/retailer-login/assets/javascripts/retailer-login.js');

'use strict';

const {
  baseUrl
} = svs.core.data;
svs.retailer_login = svs.retailer_login || {};
svs.retailer_login.data = svs.retailer_login.data || {};
const returnUrl = svs.retailer_login.data.login.url;
const changePwdElem = document.querySelector('.js-retailer-change-password-form');
if (changePwdElem) {
  new svs.components.RetailerChangePassword({
    returnUrl
  });
}
const loginElem = document.querySelector('.js-retailer-login');
if (loginElem && !changePwdElem) {
  new svs.components.RetailerLogin({
    changePwdUrl: baseUrl.concat('/byt-losenord'),
    element: loginElem,
    returnUrl,
    source: svs.retailer_login.data.source
  });
}

 })(window);